import { useCourseDetailStore } from "@/stores/courseDetailStore";
import { subchaptersOf } from "@/lib/chapterNavigation";
import { CourseTreeNodeTypeEnum } from "@/types/generated";

/**
 * Last subchapter id of the selected chapter — used when outro embeds that
 * subchapter’s content while the route still selects the chapter node.
 */
const useLastSubChapterId = (): string | undefined => {
  const selectedNodeId = useCourseDetailStore((state) => state.selectedNodeId);
  const nodeIndex = useCourseDetailStore((state) => state.nodeIndex);

  const selectedNode = selectedNodeId
    ? nodeIndex.get(selectedNodeId)?.node
    : undefined;

  if (selectedNode?.type !== CourseTreeNodeTypeEnum.Chapter) {
    return undefined;
  }

  const subchapters = subchaptersOf(selectedNode);
  return subchapters[subchapters.length - 1]?.id;
};

export { useLastSubChapterId };
